export default [
  {
    original: require("../images/gallery/TK_bei_den_Umzuegen/13.jpg"),
    thumbnail: require("../images/gallery/TK_bei_den_Umzuegen/thumb/13.jpg")
  },
  {
    original: require("../images/gallery/TK_bei_den_Umzuegen/16.jpg"),
    thumbnail: require("../images/gallery/TK_bei_den_Umzuegen/thumb/16.jpg")
  },
  {
    original: require("../images/gallery/TK_bei_den_Umzuegen/2008-05-14__MVL_Auftritt_in_Meerbusch_mit_Hartegasse_149.jpg"),
    thumbnail: require("../images/gallery/TK_bei_den_Umzuegen/thumb/2008-05-14__MVL_Auftritt_in_Meerbusch_mit_Hartegasse_149.jpg")
  },
  {
    original: require("../images/gallery/TK_bei_den_Umzuegen/2008_Schuetzenfest_Meerbusch-Buederich_(2).jpg"),
    thumbnail: require("../images/gallery/TK_bei_den_Umzuegen/thumb/2008_Schuetzenfest_Meerbusch-Buederich_(2).jpg")
  },
  {
    original: require("../images/gallery/TK_bei_den_Umzuegen/2009_Meerbusch_(2).jpg"),
    thumbnail: require("../images/gallery/TK_bei_den_Umzuegen/thumb/2009_Meerbusch_(2).jpg")
  },
  {
    original: require("../images/gallery/TK_bei_den_Umzuegen/2009_Meerbusch.jpg"),
    thumbnail: require("../images/gallery/TK_bei_den_Umzuegen/thumb/2009_Meerbusch.jpg")
  },
  {
    original: require("../images/gallery/TK_bei_den_Umzuegen/2009_Schuetzenfest_in_Hartegasse.jpg"),
    thumbnail: require("../images/gallery/TK_bei_den_Umzuegen/thumb/2009_Schuetzenfest_in_Hartegasse.jpg")
  },
  {
    original: require("../images/gallery/TK_bei_den_Umzuegen/2010_Hartegasse.jpg"),
    thumbnail: require("../images/gallery/TK_bei_den_Umzuegen/thumb/2010_Hartegasse.jpg")
  },
  {
    original: require("../images/gallery/TK_bei_den_Umzuegen/2010_Lindlar.jpg"),
    thumbnail: require("../images/gallery/TK_bei_den_Umzuegen/thumb/2010_Lindlar.jpg")
  },
  {
    original: require("../images/gallery/TK_bei_den_Umzuegen/2010_Schuetzenfest_in_Frielingsdorf.jpg"),
    thumbnail: require("../images/gallery/TK_bei_den_Umzuegen/thumb/2010_Schuetzenfest_in_Frielingsdorf.jpg")
  },
  {
    original: require("../images/gallery/TK_bei_den_Umzuegen/2010_Schuetzenfest_in_Hartegasse_(3).jpg"),
    thumbnail: require("../images/gallery/TK_bei_den_Umzuegen/thumb/2010_Schuetzenfest_in_Hartegasse_(3).jpg")
  },
  {
    original: require("../images/gallery/TK_bei_den_Umzuegen/2010_Schuetzenfest_in_Hartegasse.jpg"),
    thumbnail: require("../images/gallery/TK_bei_den_Umzuegen/thumb/2010_Schuetzenfest_in_Hartegasse.jpg")
  },
  {
    original: require("../images/gallery/TK_bei_den_Umzuegen/2012_Helling.jpg"),
    thumbnail: require("../images/gallery/TK_bei_den_Umzuegen/thumb/2012_Helling.jpg")
  },
  {
    original: require("../images/gallery/TK_bei_den_Umzuegen/2012_Remshagen_100_Jahre_Feuerwehr.jpg"),
    thumbnail: require("../images/gallery/TK_bei_den_Umzuegen/thumb/2012_Remshagen_100_Jahre_Feuerwehr.jpg")
  },
  {
    original: require("../images/gallery/TK_bei_den_Umzuegen/2012_Schuetzenfest_in_Vollmerhauen.jpg"),
    thumbnail: require("../images/gallery/TK_bei_den_Umzuegen/thumb/2012_Schuetzenfest_in_Vollmerhauen.jpg")
  },
  {
    original: require("../images/gallery/TK_bei_den_Umzuegen/2012_Schuetzenfest_in_Vollmerhausen.jpg"),
    thumbnail: require("../images/gallery/TK_bei_den_Umzuegen/thumb/2012_Schuetzenfest_in_Vollmerhausen.jpg")
  },
  {
    original: require("../images/gallery/TK_bei_den_Umzuegen/2012_Schuetzenfest_Meerbusch-Buederich_(2).jpg"),
    thumbnail: require("../images/gallery/TK_bei_den_Umzuegen/thumb/2012_Schuetzenfest_Meerbusch-Buederich_(2).jpg")
  },
  {
    original: require("../images/gallery/TK_bei_den_Umzuegen/2012_Schuetzenfest_Meerbusch-Buederich.jpg"),
    thumbnail: require("../images/gallery/TK_bei_den_Umzuegen/thumb/2012_Schuetzenfest_Meerbusch-Buederich.jpg")
  },
  {
    original: require("../images/gallery/TK_bei_den_Umzuegen/41.jpg"),
    thumbnail: require("../images/gallery/TK_bei_den_Umzuegen/thumb/41.jpg")
  },
  {
    original: require("../images/gallery/TK_bei_den_Umzuegen/43.jpg"),
    thumbnail: require("../images/gallery/TK_bei_den_Umzuegen/thumb/43.jpg")
  },
  {
    original: require("../images/gallery/TK_bei_den_Umzuegen/45.jpg"),
    thumbnail: require("../images/gallery/TK_bei_den_Umzuegen/thumb/45.jpg")
  },
  {
    original: require("../images/gallery/TK_bei_den_Umzuegen/Bild_096.jpg"),
    thumbnail: require("../images/gallery/TK_bei_den_Umzuegen/thumb/Bild_096.jpg")
  },
  {
    original: require("../images/gallery/TK_bei_den_Umzuegen/bild_homepage.jpg"),
    thumbnail: require("../images/gallery/TK_bei_den_Umzuegen/thumb/bild_homepage.jpg")
  },
  {
    original: require("../images/gallery/TK_bei_den_Umzuegen/Bilder_Dieter_Wolff__www-Hausi-Home-de_(119).jpg"),
    thumbnail: require("../images/gallery/TK_bei_den_Umzuegen/thumb/Bilder_Dieter_Wolff__www-Hausi-Home-de_(119).jpg")
  },
  {
    original: require("../images/gallery/TK_bei_den_Umzuegen/Bilder_Dieter_Wolff__www-Hausi-Home-de_(154).jpg"),
    thumbnail: require("../images/gallery/TK_bei_den_Umzuegen/thumb/Bilder_Dieter_Wolff__www-Hausi-Home-de_(154).jpg")
  },
  {
    original: require("../images/gallery/TK_bei_den_Umzuegen/Bilder_Dieter_Wolff__www-Hausi-Home-de_(17).jpg"),
    thumbnail: require("../images/gallery/TK_bei_den_Umzuegen/thumb/Bilder_Dieter_Wolff__www-Hausi-Home-de_(17).jpg")
  },
  {
    original: require("../images/gallery/TK_bei_den_Umzuegen/Bilder_Dieter_Wolff__www-Hausi-Home-de_(320).jpg"),
    thumbnail: require("../images/gallery/TK_bei_den_Umzuegen/thumb/Bilder_Dieter_Wolff__www-Hausi-Home-de_(320).jpg")
  },
  {
    original: require("../images/gallery/TK_bei_den_Umzuegen/Bilder_Dieter_Wolff__www-Hausi-Home-de_(350).jpg"),
    thumbnail: require("../images/gallery/TK_bei_den_Umzuegen/thumb/Bilder_Dieter_Wolff__www-Hausi-Home-de_(350).jpg")
  },
  {
    original: require("../images/gallery/TK_bei_den_Umzuegen/CIMG3409.jpg"),
    thumbnail: require("../images/gallery/TK_bei_den_Umzuegen/thumb/CIMG3409.jpg")
  },
  {
    original: require("../images/gallery/TK_bei_den_Umzuegen/CIMG3413.jpg"),
    thumbnail: require("../images/gallery/TK_bei_den_Umzuegen/thumb/CIMG3413.jpg")
  },
  {
    original: require("../images/gallery/TK_bei_den_Umzuegen/CIMG3416.jpg"),
    thumbnail: require("../images/gallery/TK_bei_den_Umzuegen/thumb/CIMG3416.jpg")
  },
  {
    original: require("../images/gallery/TK_bei_den_Umzuegen/CIMG3548.jpg"),
    thumbnail: require("../images/gallery/TK_bei_den_Umzuegen/thumb/CIMG3548.jpg")
  },
  {
    original: require("../images/gallery/TK_bei_den_Umzuegen/CIMG6690.jpg"),
    thumbnail: require("../images/gallery/TK_bei_den_Umzuegen/thumb/CIMG6690.jpg")
  },
  {
    original: require("../images/gallery/TK_bei_den_Umzuegen/Das_Korps_an_der_Suenger_Kirche.jpg"),
    thumbnail: require("../images/gallery/TK_bei_den_Umzuegen/thumb/Das_Korps_an_der_Suenger_Kirche.jpg")
  },
  {
    original: require("../images/gallery/TK_bei_den_Umzuegen/DSC04574.jpg"),
    thumbnail: require("../images/gallery/TK_bei_den_Umzuegen/thumb/DSC04574.jpg")
  },
  {
    original: require("../images/gallery/TK_bei_den_Umzuegen/DSC05926.jpg"),
    thumbnail: require("../images/gallery/TK_bei_den_Umzuegen/thumb/DSC05926.jpg")
  },
  {
    original: require("../images/gallery/TK_bei_den_Umzuegen/DSC05946.jpg"),
    thumbnail: require("../images/gallery/TK_bei_den_Umzuegen/thumb/DSC05946.jpg")
  },
  {
    original: require("../images/gallery/TK_bei_den_Umzuegen/DSCF0095.jpg"),
    thumbnail: require("../images/gallery/TK_bei_den_Umzuegen/thumb/DSCF0095.jpg")
  },
  {
    original: require("../images/gallery/TK_bei_den_Umzuegen/DSCF0097.jpg"),
    thumbnail: require("../images/gallery/TK_bei_den_Umzuegen/thumb/DSCF0097.jpg")
  },
  {
    original: require("../images/gallery/TK_bei_den_Umzuegen/Gruppenbild_Schule-dunkelblau.jpg"),
    thumbnail: require("../images/gallery/TK_bei_den_Umzuegen/thumb/Gruppenbild_Schule-dunkelblau.jpg")
  },
  {
    original: require("../images/gallery/TK_bei_den_Umzuegen/Hartegasse_Mo_22.jpg"),
    thumbnail: require("../images/gallery/TK_bei_den_Umzuegen/thumb/Hartegasse_Mo_22.jpg")
  },
  {
    original: require("../images/gallery/TK_bei_den_Umzuegen/Hartegasse_So_11.jpg"),
    thumbnail: require("../images/gallery/TK_bei_den_Umzuegen/thumb/Hartegasse_So_11.jpg")
  },
  {
    original: require("../images/gallery/TK_bei_den_Umzuegen/IMGP0156.jpg"),
    thumbnail: require("../images/gallery/TK_bei_den_Umzuegen/thumb/IMGP0156.jpg")
  },
  {
    original: require("../images/gallery/TK_bei_den_Umzuegen/IMG_7643.jpg"),
    thumbnail: require("../images/gallery/TK_bei_den_Umzuegen/thumb/IMG_7643.jpg")
  },
  {
    original: require("../images/gallery/TK_bei_den_Umzuegen/Schuetzenfest_in_Hartegasse_neu.jpg"),
    thumbnail: require("../images/gallery/TK_bei_den_Umzuegen/thumb/Schuetzenfest_in_Hartegasse_neu.jpg")
  }
];



// WEBPACK FOOTER //
// ./src/components/gallerylists/imagesuemzuege.js